export interface OrganizationConfig {
  shortName: string;
  name: string;
  urls: string[];
  loggedInRedirectToUrl: string;
  mailEnding: string[];
  //will be removed after https://gitlab.gyselroth.net/move2one/ui-web/-/issues/86
  moodleRedirectLink?: string;
  loginType: 'azure' | 'aai';
}

export const basicScopes = ['openid', 'profile', 'offline_access'];
export const mailScopes = ['Mail.read'];
export const teamsScopes = [
  'user.read',
  'User.ReadBasic.All',
  'Channel.ReadBasic.All',
  'Team.ReadBasic.All',
  'ChannelMessage.Read.All',
];
export const m2oAPIScopes = [
  'api://d0349e9f-7609-43f3-beee-6cf2ac3ccccb/move2one',
];
export const grAPIScopes = [
  'api://aea6d97b-a3da-41dc-b2d0-3f8d9324cbed/graphql',
];

export const organizationConfigs: OrganizationConfig[] = [
  {
    shortName: 'gr',
    name: 'Gyselroth',
    urls: [
      'http://localhost:4200',
      'http://gr.localhost:4200',
      'https://gr.move2one.gyselroth.net',
    ],
    loggedInRedirectToUrl: 'dashboard/ms-mails',
    mailEnding: ['gyselroth.com'],
    loginType: 'azure',
  },
  {
    shortName: 'kst',
    name: 'Kantonsschule Stadelhofen',
    urls: [
      'http://kst.localhost:4200',
      'https://kst.move2one.gyselroth.net',
      'https://move2one.gyselroth.net',
      'https://movetoone.ksstadelhofen.ch',
    ],
    loggedInRedirectToUrl: 'dashboard/news',
    mailEnding: ['ksstadelhofen.ch'],
    moodleRedirectLink:
      'https://moodle.ksstadelhofen.ch/nanoo.security/login.php',
    loginType: 'azure',
  },
];
